module.exports = __webpack_public_path__ + "img/9_of_Clubs.svg.72755ce1.png";